import React from 'react';
import {
    Select,
    Stack
} from '@shopify/polaris';
import { SelectFilterTypes } from '../common/Helpers';

const varianOperatorOptions = [
    { label: 'is in stock', value: 'IsAvailable' },
    { label: 'is not in stock', value: 'IsNotAvailable' }
];

class ProductVariantOptionFilterComponent extends React.Component {

    state = {};

    render() {

        let options = [
            { label: "--- Choose option ---", value: "" },
            ...this.props.valueOptions,
        ];

        return (
            <Stack alignment="center" spacing="tight">
                <Select
                    options={SelectFilterTypes}
                    value={this.props.filter.filterType}
                    onChange={(selected, id) => this.onFilterTypeChange(selected)}
                />
                <Select
                    options={varianOperatorOptions}
                    value={this.props.filter.operator}
                    onChange={(selected, id) => this.onOperatorChange(selected)}
                />
                <Select
                    options={options}
                    value={this.props.filter.option}
                    onChange={(selected, id) => this.onOptionChange(selected)}
                />
            </Stack>
        );
    }

    onFilterTypeChange = (newValue) => {
        let newFilter = JSON.parse(JSON.stringify(this.props.filter));
        newFilter.filterType = newValue;

        this.props.onFilterUpdated(newFilter);
    }

    onOperatorChange = (newValue) => {
        let newFilter = JSON.parse(JSON.stringify(this.props.filter));
        newFilter.operator = newValue;

        this.props.onFilterUpdated(newFilter);
    }

    onOptionChange = (newValue) => {
        let newFilter = JSON.parse(JSON.stringify(this.props.filter));
        newFilter.option = newValue;

        this.props.onFilterUpdated(newFilter);
    }
}

export default ProductVariantOptionFilterComponent;
